document.addEventListener('DOMContentLoaded',function(){
  var productPromise;

  function standardizeTrust(){
    var desired=[
      '🔒 Pago seguro',
      '📦 Envío gratis + seguimiento',
      '↩️ 30 días de garantía'
    ];

    document.querySelectorAll('[data-wwpdp]').forEach(function(root){
      root.querySelectorAll('[class*="trust"]').forEach(function(block){
        var items=Array.from(block.children).filter(function(el){
          return /^(SPAN|DIV|P|LI)$/.test(el.tagName);
        });
        var text=(block.textContent||'').replace(/\s+/g,' ').trim();

        if(items.length>=3 && /(Pago seguro|Envío|garant|Recibes el acabado|Soporte WizzyWand)/i.test(text)){
          items[0].textContent=desired[0];
          items[1].textContent=desired[1];
          items[2].textContent=desired[2];
        }
      });

      root.querySelectorAll('span,div,p,li').forEach(function(el){
        if(el.children.length)return;
        var text=(el.textContent||'').replace(/\s+/g,' ').trim();

        if(/^(🔒\s*)?(Pago seguro|Pago seguro con Shopify)$/i.test(text)){
          el.textContent=desired[0];
        }else if(/^(📦\s*)?(Envío calculado en checkout|Envío según destino · coste antes de pagar|Envío gratis \+ seguimiento)$/i.test(text)){
          el.textContent=desired[1];
        }else if(/^(✓\s*)?(Recibes el acabado elegido|Soporte WizzyWand y devoluciones claras)$/i.test(text) || /^(↩️\s*)?30 días de garantía$/i.test(text)){
          el.textContent=desired[2];
        }
      });
    });

    document.querySelectorAll('.wn-micro').forEach(function(note){note.remove();});
  }

  function swapImage(img,url,alt){
    if(!img||!url)return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src=url;
    if(alt)img.alt=alt;
  }

  function getProduct(){
    if(!productPromise){
      var path=window.location.pathname.replace(/\/$/,'')+'.js';
      productPromise=fetch(path,{headers:{Accept:'application/json'}})
        .then(function(r){if(!r.ok)throw new Error('product json');return r.json();})
        .catch(function(){return null;});
    }
    return productPromise;
  }

  document.querySelectorAll('[data-wwpdp]').forEach(function(root){
    var main=root.querySelector('[data-main-image]');
    var thumbs=root.querySelectorAll('[data-thumb]');

    thumbs.forEach(function(btn){
      btn.addEventListener('click',function(){
        swapImage(main,btn.dataset.src,btn.dataset.alt||'');
        thumbs.forEach(function(b){b.classList.remove('is-active','active');});
        btn.classList.add('is-active');
      });
    });

    var sel=root.querySelector('[data-variant]');
    var price=root.querySelector('[data-price]');
    var atc=root.querySelector('[data-atc]');

    if(sel){
      var sync=function(){
        var o=sel.options[sel.selectedIndex];

        if(price&&o.dataset.price)price.textContent=o.dataset.price;

        if(atc){
          var ok=o.dataset.available==='true';
          atc.disabled=!ok;
          atc.textContent=ok?'Añadir al carrito':'Agotado';
        }

        if(o.dataset.image){
          swapImage(main,o.dataset.image,o.dataset.alt||'');
          return;
        }

        getProduct().then(function(prod){
          if(!prod||!prod.variants)return;
          var v=prod.variants.find(function(x){
            return String(x.id)===String(o.value);
          });
          var fi=v&&v.featured_image;
          var url=fi&&(fi.src||fi);
          if(url)swapImage(main,url,(fi&&fi.alt)||'');
        });
      };

      sel.addEventListener('change',sync);
      sync();
    }
  });

  standardizeTrust();
});